export default __webpack_public_path__ + "static/media/spider-arthropod-animal-silhouette-1.c3b6d18c.svg";